import type { Mandate } from "@kollectivia/shared";
import { useQuery } from "@tanstack/react-query";

import { api } from "../api";

export function useCompanyMandates(companyId: string | undefined, projectId?: string) {
  return useQuery({
    queryKey: ["mandates", companyId, projectId],
    queryFn: () =>
      api.get<{ items: Mandate[] }>(
        `/v1/mandates?company_id=${encodeURIComponent(companyId!)}${projectId ? `&project_id=${encodeURIComponent(projectId)}` : ""}`,
      ),
    enabled: !!companyId,
    staleTime: 0,
    refetchOnWindowFocus: true,
    refetchInterval: 15_000,
    refetchIntervalInBackground: false,
  });
}
